
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <g clip-path="url(#clip0_2_114)" fill-rule="evenodd" clip-rule="evenodd"><path d="M14.58 8.697a1 1 0 01-.291 1.383L8 14.18 1.711 10.08a1 1 0 111.092-1.675L8 11.792l5.197-3.387a1 1 0 011.383.292z"></path><path d="M14.58 3.197a1 1 0 01-.291 1.383L8 8.68 1.711 4.58a1 1 0 111.092-1.675L8 6.292l5.197-3.387a1 1 0 011.383.292z"></path></g><defs><clipPath id="clip0_2_114"><rect width="16" height="16"></rect></clipPath></defs>
    </svg>
  </template>
  <script>
    export default {
      name: "IconPackopen",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
